import { View, Utils } from '../vendor/kerneljs';

const TagsSelectorOverlay = View.extend({
	triggered:false,
	events: {
		'click .js--tags-selector-overlay-trigger': 'triggerOverlayHandler',
		'click .js--tags-selector-overlay-close': 'closeOverlayHandler'
	},
	initialize:function() {
		this.overlayRef = this.find('.js--tags-selector-overlay-content');
	},
	triggerOverlayHandler: function() {
		if ( this.overlayOpen ) return false;
		this.overlayOpen = true;

		setTimeout(function(){
			this.overlayRef.setAttribute('style','display:block;');
			setTimeout(function(){Utils.addClass(this.overlayRef,'is-active');}.bind(this), 50);
		}.bind(this), 50);
	},
	closeOverlayHandler: function() {
		this.overlayOpen = false;
		Utils.removeClass(this.overlayRef,'is-active');
		setTimeout(function(){
			this.overlayRef.setAttribute('style','');
		}.bind(this), 300);
	}
});

(function(){
	Utils.each(Utils.find('.js--tags-selector-overlay'), function(elem) {
		new TagsSelectorOverlay( {el: elem} );
	});

})();

export default TagsSelectorOverlay;